import * as angular from 'angular';
import * as _ from 'lodash';

import { HistorianStorageQueryResultDto,ComponentDefinition } from '../../../../models';

class StorageConfigurationExecutionResultController implements angular.IComponentController {
    hasGroupBy: boolean = false;

    readonly isLoading: boolean;
    readonly results: HistorianStorageQueryResultDto[];

    static $inject = [];

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['results']?.currentValue) {
            this.hasGroupBy = _.some(this.results, r => r.groupBy);
        }
    }
}

export const wtStorageConfigurationExecutionResult: ComponentDefinition = {
    componentId: 'wtStorageConfigurationExecutionResult',
    controller: StorageConfigurationExecutionResultController,
    template: require('./storageConfiguration.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<?',
        results: '<?'
    }
};